var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.editType == "edit" ? "编辑会员商品" : "新增会员商品",
            visible: _vm.value,
            "append-to-body": "",
            width: `${900}px`,
            top: "80px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.value = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticStyle: { padding: "15px" },
              attrs: {
                model: _vm.formChild,
                "label-width": "120px",
                size: "small",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-collapse",
                {
                  model: {
                    value: _vm.activeNames,
                    callback: function ($$v) {
                      _vm.activeNames = $$v
                    },
                    expression: "activeNames",
                  },
                },
                [
                  _c(
                    "el-collapse-item",
                    { attrs: { name: "1" } },
                    [
                      _c("template", { slot: "title" }, [
                        _c(
                          "div",
                          { staticClass: "_title" },
                          [
                            _vm._v(
                              "\n              商品基础配置\n\n              "
                            ),
                            _c("el-tooltip", { attrs: { placement: "top" } }, [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _c("ul", [
                                    _c("li", [
                                      _vm._v(
                                        "会员类型：选择商品的的会员类型，保存后不可更改"
                                      ),
                                    ]),
                                    _c("li", [
                                      _vm._v(
                                        "\n                      商品类型：区分商品是在客户端上的，还是做活动用的，保存后不可更改\n                    "
                                      ),
                                    ]),
                                    _c("li", [
                                      _vm._v(
                                        "商品编号：配置时手动填写，保存后不可更改"
                                      ),
                                    ]),
                                    _c("li", [
                                      _vm._v(
                                        "\n                      商品名称：配置时手动填写，同一会员类型商品名称不可重复，保存后不可更改\n                    "
                                      ),
                                    ]),
                                  ]),
                                ]
                              ),
                              _c("i", {
                                staticClass: "header-icon el-icon-info",
                              }),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "_box" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "会员类型",
                                prop: "memberTypeId",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "_width_214",
                                  attrs: {
                                    placeholder: "请选择会员类型",
                                    disabled: _vm.editType == "edit",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.changeMemberTypeId(
                                        _vm.formChild.memberTypeId
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.formChild.memberTypeId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formChild,
                                        "memberTypeId",
                                        $$v
                                      )
                                    },
                                    expression: "formChild.memberTypeId",
                                  },
                                },
                                _vm._l(
                                  _vm.bizCode.member_type,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.dictKey,
                                      attrs: {
                                        label: `${item.dictValue} (${item.dictKey})`,
                                        value: +item.dictKey,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "商品类型", prop: "goodsType" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  attrs: { disabled: _vm.editType == "edit" },
                                  on: {
                                    change: function ($event) {
                                      return _vm.changeGoodsType(
                                        _vm.formChild.goodsType
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.formChild.goodsType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formChild, "goodsType", $$v)
                                    },
                                    expression: "formChild.goodsType",
                                  },
                                },
                                _vm._l(_vm.bizCode.goods_type, function (item) {
                                  return _c(
                                    "el-radio",
                                    {
                                      key: item.dictKey,
                                      attrs: { label: item.dictKey },
                                    },
                                    [_vm._v(_vm._s(item.dictValue))]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "商品编号", prop: "goodsCode" } },
                            [
                              _c("el-input", {
                                staticClass: "_width_370",
                                attrs: {
                                  placeholder: "请输入会员商品编号",
                                  maxlength: "99",
                                  witch: "214",
                                  disabled: _vm.editType == "edit",
                                },
                                model: {
                                  value: _vm.formChild.goodsCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formChild, "goodsCode", $$v)
                                  },
                                  expression: "formChild.goodsCode",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "商品名称", prop: "goodsName" } },
                            [
                              _c("el-input", {
                                staticClass: "_width_370",
                                attrs: {
                                  placeholder: "请输入会员商品名称",
                                  maxlength: "99",
                                  disabled: _vm.editType == "edit",
                                },
                                model: {
                                  value: _vm.formChild.goodsName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formChild, "goodsName", $$v)
                                  },
                                  expression: "formChild.goodsName",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.formChild.goodsType == 2
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "销售场景" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "_width_214",
                                      attrs: {
                                        placeholder: "请选择销售场景",
                                        disabled: false,
                                      },
                                      model: {
                                        value: _vm.formChild.activityType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formChild,
                                            "activityType",
                                            $$v
                                          )
                                        },
                                        expression: "formChild.activityType",
                                      },
                                    },
                                    _vm._l(
                                      _vm.bizCode.member_goods_activity_type,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.dictKey,
                                          attrs: {
                                            label: item.dictValue,
                                            value: item.dictKey,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formChild.goodsType == 2
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "活动ID" } },
                                [
                                  _c("el-input", {
                                    staticClass: "_width_370",
                                    attrs: {
                                      placeholder: "请输入活动ID,非活动不填",
                                      maxlength: "999",
                                    },
                                    model: {
                                      value: _vm.formChild.activityId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formChild,
                                          "activityId",
                                          $$v
                                        )
                                      },
                                      expression: "formChild.activityId",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "el-collapse-item",
                    { attrs: { name: "2" } },
                    [
                      _c("template", { slot: "title" }, [
                        _c(
                          "div",
                          { staticClass: "_title" },
                          [
                            _vm._v(
                              "\n              商品展示配置\n              "
                            ),
                            _c("el-tooltip", { attrs: { placement: "top" } }, [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _c("ul", [
                                    _c("li", [
                                      _vm._v(
                                        "限制购买次数：若配置 1 次，则购买后商品下架"
                                      ),
                                    ]),
                                    _c("li", [
                                      _vm._v(
                                        "\n                      销售端类型：代表商品可在哪些端卖，可添加的端为上面所选的会员类型携带，所选的端代表该端下的对应的所有渠道\n                    "
                                      ),
                                    ]),
                                    _c("li", [
                                      _vm._v(
                                        "\n                      前端可见：代表该商品是否可在客户端呈现，例如活动商品配置为不可见状态。\n                    "
                                      ),
                                    ]),
                                    _c("li", [
                                      _vm._v(
                                        "\n                      显示顺序：通过输入数值来排序，若数值相同，则按照创建时间排序\n                    "
                                      ),
                                    ]),
                                    _c("li", [
                                      _vm._v(
                                        "\n                      可见人群：决定该商品对哪些人群可见；未登录用户仅在「全部用户」、或用户类型勾选了「游客」时可见\n                    "
                                      ),
                                    ]),
                                    _c("li", [
                                      _vm._v(
                                        "\n                      指定用户：名单为一次性快照，需要变更时请重新上传覆盖\n                    "
                                      ),
                                    ]),
                                  ]),
                                ]
                              ),
                              _c("i", {
                                staticClass: "header-icon el-icon-info",
                              }),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "_box" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "销售端类型", prop: "key7" } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", plain: "" },
                                  on: { click: _vm.addTypeItem },
                                },
                                [_vm._v("添加销售端")]
                              ),
                              _vm._l(
                                _vm.formChild.saleChannelList,
                                function (item, index) {
                                  return _c("div", { key: index }, [
                                    _c(
                                      "div",
                                      { staticStyle: { "margin-top": "15px" } },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            directives: [
                                              {
                                                name: "loading",
                                                rawName: "v-loading",
                                                value: _vm.client_types_loading,
                                                expression:
                                                  "client_types_loading",
                                              },
                                            ],
                                            staticClass: "_width_214",
                                            attrs: {
                                              placeholder: "请选择客户端",
                                              disabled:
                                                !_vm.formChild.memberTypeId,
                                            },
                                            model: {
                                              value: item.clientType,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "clientType",
                                                  $$v
                                                )
                                              },
                                              expression: "item.clientType",
                                            },
                                          },
                                          _vm._l(
                                            _vm.bizCode.client_types,
                                            function (item) {
                                              return _c("el-option", {
                                                key: item.dictKey,
                                                attrs: {
                                                  disabled:
                                                    _vm.cleanUpDuplicates(
                                                      item.dictKey
                                                    ),
                                                  label: item.dictValue,
                                                  value: item.dictKey,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                        _c(
                                          "el-select",
                                          {
                                            staticClass: "_width_214",
                                            staticStyle: { margin: "0 25px" },
                                            attrs: {
                                              placeholder: "请选择渠道",
                                            },
                                            model: {
                                              value: item.channelType,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "channelType",
                                                  $$v
                                                )
                                              },
                                              expression: "item.channelType",
                                            },
                                          },
                                          _vm._l(
                                            _vm.bizCode.channel_type,
                                            function (item) {
                                              return _c("el-option", {
                                                key: item.dictKey,
                                                attrs: {
                                                  label: item.dictValue,
                                                  value: item.dictKey,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            staticStyle: { color: "#ff0000" },
                                            attrs: {
                                              type: "text",
                                              icon: "el-icon-delete",
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.formChild.saleChannelList =
                                                  _vm.formChild.saleChannelList.filter(
                                                    (i) => i !== item
                                                  )
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        ),
                                      ],
                                      1
                                    ),
                                    item.channelType != 1 && item.channelType
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              margin: "15px 0 15px -120px",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  prop: "appidFilterNames",
                                                  label: "指定渠道",
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    type: "textarea",
                                                    rows: "3",
                                                  },
                                                  on: {
                                                    focus: function ($event) {
                                                      return _vm.handleClick(
                                                        index
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: item.channelNames,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "channelNames",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.channelNames",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ])
                                }
                              ),
                            ],
                            2
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "前端可见",
                                prop: "frontVisible",
                              },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.formChild.frontVisible,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formChild,
                                        "frontVisible",
                                        $$v
                                      )
                                    },
                                    expression: "formChild.frontVisible",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: "1" } }, [
                                    _vm._v("是"),
                                  ]),
                                  _c("el-radio", { attrs: { label: "0" } }, [
                                    _vm._v("否"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "显示顺序",
                                prop: "displayOrder",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "_width_370",
                                attrs: {
                                  maxlength: "9999",
                                  placeholder: "请输入显示顺序",
                                },
                                nativeOn: {
                                  keypress: function ($event) {
                                    return _vm.onKeyPress.apply(null, arguments)
                                  },
                                },
                                model: {
                                  value: _vm.formChild.displayOrder,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formChild, "displayOrder", $$v)
                                  },
                                  expression: "formChild.displayOrder",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "可见人群", prop: "visibleType" },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.formChild.visibleType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formChild,
                                        "visibleType",
                                        $$v
                                      )
                                    },
                                    expression: "formChild.visibleType",
                                  },
                                },
                                _vm._l(_vm.visibleTypeOptions, function (item) {
                                  return _c(
                                    "el-radio",
                                    {
                                      key: item.value,
                                      attrs: { label: item.value },
                                    },
                                    [_vm._v(_vm._s(item.label))]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.formChild.visibleType ===
                          _vm.visibleTypeEnum.USER_TAG
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "用户标签",
                                    prop: "visibleUserTags",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "_width_370",
                                      attrs: {
                                        placeholder: "请选择用户标签",
                                        multiple: "",
                                        filterable: "",
                                        "collapse-tags": "",
                                      },
                                      model: {
                                        value: _vm.formChild.visibleUserTags,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formChild,
                                            "visibleUserTags",
                                            $$v
                                          )
                                        },
                                        expression: "formChild.visibleUserTags",
                                      },
                                    },
                                    _vm._l(
                                      _vm.bizCode.label_user_tag,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.dictKey,
                                          attrs: {
                                            label: item.dictValue,
                                            value: item.dictKey,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formChild.visibleType ===
                          _vm.visibleTypeEnum.USER_TYPE
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "用户类型",
                                    prop: "visibleUserTypes",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "_width_370",
                                      attrs: {
                                        placeholder: "请选择用户类型",
                                        multiple: "",
                                        "collapse-tags": "",
                                      },
                                      model: {
                                        value: _vm.formChild.visibleUserTypes,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formChild,
                                            "visibleUserTypes",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formChild.visibleUserTypes",
                                      },
                                    },
                                    _vm._l(
                                      _vm.visibleUserTypeOptions,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.dictKey,
                                          attrs: {
                                            label: item.dictValue,
                                            value: item.dictKey,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formChild.visibleType ===
                          _vm.visibleTypeEnum.PHONE_LIST
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "指定用户",
                                    prop: "visiblePhoneCount",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "visible_phone_actions" },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            plain: "",
                                            size: "small",
                                          },
                                          on: {
                                            click:
                                              _vm.downloadVisiblePhoneTemplate,
                                          },
                                        },
                                        [_vm._v("下载模板")]
                                      ),
                                      _c(
                                        "el-upload",
                                        {
                                          staticClass: "visible_phone_upload",
                                          attrs: {
                                            action: "",
                                            "show-file-list": false,
                                            multiple: false,
                                            "before-upload":
                                              _vm.beforeVisiblePhoneUpload,
                                            "http-request":
                                              _vm.importVisiblePhone,
                                          },
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "small",
                                                loading:
                                                  _vm.visiblePhoneUploading,
                                              },
                                            },
                                            [_vm._v("上传名单")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.formChild.visiblePhoneCount > 0
                                        ? [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "text",
                                                  size: "small",
                                                },
                                                on: {
                                                  click:
                                                    _vm.downloadVisiblePhone,
                                                },
                                              },
                                              [_vm._v("下载已导入名单")]
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                staticStyle: {
                                                  color: "#ff0000",
                                                },
                                                attrs: {
                                                  type: "text",
                                                  size: "small",
                                                },
                                                on: {
                                                  click: _vm.clearVisiblePhone,
                                                },
                                              },
                                              [_vm._v("清空重传")]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "visible_phone_tip" },
                                    [
                                      _vm.formChild.visiblePhoneCount > 0
                                        ? _c("span", [
                                            _vm._v(
                                              "已导入 " +
                                                _vm._s(
                                                  _vm.formChild
                                                    .visiblePhoneCount
                                                ) +
                                                " 条"
                                            ),
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              "请上传手机号名单，仅支持 xlsx/xls，单次最多 " +
                                                _vm._s(
                                                  _vm.visiblePhoneMaxCount
                                                ) +
                                                " 条"
                                            ),
                                          ]),
                                    ]
                                  ),
                                  _vm.visiblePhoneImportResult
                                    ? _c(
                                        "div",
                                        { staticClass: "visible_phone_result" },
                                        [
                                          _c("div", [
                                            _vm._v(
                                              "\n                  本次上传 " +
                                                _vm._s(
                                                  _vm.visiblePhoneImportResult
                                                    .totalRows
                                                ) +
                                                " 行，合法 " +
                                                _vm._s(
                                                  _vm.visiblePhoneImportResult
                                                    .validRows
                                                ) +
                                                " 行，去重后 " +
                                                _vm._s(
                                                  _vm.visiblePhoneImportResult
                                                    .distinctCount
                                                ) +
                                                " 条\n                "
                                            ),
                                          ]),
                                          _vm.visiblePhoneImportResult
                                            .invalidRowText
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "visible_phone_invalid",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  非法行号：" +
                                                      _vm._s(
                                                        _vm
                                                          .visiblePhoneImportResult
                                                          .invalidRowText
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "el-collapse-item",
                    { attrs: { name: "3" } },
                    [
                      _c("template", { slot: "title" }, [
                        _c(
                          "div",
                          { staticClass: "_title" },
                          [
                            _vm._v(
                              "\n              商品定价配置\n              "
                            ),
                            _c("el-tooltip", { attrs: { placement: "top" } }, [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _c("ul", [
                                    _c("li", [
                                      _vm._v(
                                        "限制购买次数：若配置 1 次，则购买后商品下架"
                                      ),
                                    ]),
                                  ]),
                                ]
                              ),
                              _c("i", {
                                staticClass: "header-icon el-icon-info",
                              }),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "_box" },
                        [
                          _vm.isShowAutoRenewFlag
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "自动续费商品",
                                    prop: "autoRenewFlag",
                                  },
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: {
                                        disabled: _vm.editType == "edit",
                                      },
                                      model: {
                                        value: _vm.formChild.autoRenewFlag,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formChild,
                                            "autoRenewFlag",
                                            $$v
                                          )
                                        },
                                        expression: "formChild.autoRenewFlag",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "1" } },
                                        [_vm._v("是")]
                                      ),
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "0" } },
                                        [_vm._v("否")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formChild.autoRenewFlag == "0"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "定价周期",
                                        prop: "salePeriod",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        [
                                          _c("el-input", {
                                            staticClass: "_width_214",
                                            attrs: {
                                              placeholder: "请输入数字",
                                              maxlength: "99",
                                              disabled: _vm.editType == "edit",
                                            },
                                            on: { input: _vm.getPresentPrice },
                                            nativeOn: {
                                              keypress: function ($event) {
                                                return _vm.onKeyPress.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                            model: {
                                              value: _vm.formChild.salePeriod,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formChild,
                                                  "salePeriod",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formChild.salePeriod",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "_width_214",
                                          staticStyle: { "margin-top": "15px" },
                                          attrs: {
                                            placeholder: "请选择周期",
                                            disabled: _vm.editType == "edit",
                                          },
                                          on: { change: _vm.getPresentPrice },
                                          model: {
                                            value: _vm.formChild.salePeriodUnit,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formChild,
                                                "salePeriodUnit",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formChild.salePeriodUnit",
                                          },
                                        },
                                        _vm._l(
                                          _vm.bizCode.sale_period_unit,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.dictKey,
                                              attrs: {
                                                label: item.dictValue,
                                                value: item.dictKey,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "售价",
                                        prop: "salePrice",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticStyle: { display: "flex" } },
                                        [
                                          _c("el-input", {
                                            staticClass: "_width_214",
                                            attrs: {
                                              maxlength: "99",
                                              placeholder: "请输入售价",
                                            },
                                            on: { input: _vm.getPresentPrice },
                                            nativeOn: {
                                              keypress: function ($event) {
                                                return _vm.formatInput.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                            model: {
                                              value: _vm.formChild.salePrice,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formChild,
                                                  "salePrice",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "formChild.salePrice",
                                            },
                                          }),
                                          _vm.formChild.memberTypeKey == 5
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "5px",
                                                  },
                                                },
                                                [_vm._v(" 元/台")]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "5px",
                                                  },
                                                },
                                                [_vm._v(" 元")]
                                              ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "限制购买次数",
                                        prop: "limitPurchaseTimesFlag",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          model: {
                                            value:
                                              _vm.formChild
                                                .limitPurchaseTimesFlag,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formChild,
                                                "limitPurchaseTimesFlag",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formChild.limitPurchaseTimesFlag",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: "0" } },
                                            [_vm._v("不限制")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: "1" } },
                                            [_vm._v("1次")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "支付方式",
                                        prop: "autoRenewPayType",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-checkbox-group",
                                        {
                                          model: {
                                            value:
                                              _vm.formChild.autoRenewPayType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formChild,
                                                "autoRenewPayType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formChild.autoRenewPayType",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-checkbox",
                                            { attrs: { label: "1" } },
                                            [_vm._v("微信支付")]
                                          ),
                                          _c(
                                            "el-checkbox",
                                            { attrs: { label: "2" } },
                                            [_vm._v("支付宝支付")]
                                          ),
                                          _c(
                                            "el-checkbox",
                                            { attrs: { label: "5" } },
                                            [_vm._v("IOS支付")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  Array.isArray(
                                    _vm.formChild.autoRenewPayType
                                  ) &&
                                  _vm.formChild.autoRenewPayType.includes("1")
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "微信模板ID",
                                            prop: "wechatTemplateId",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass: "_width_214",
                                            attrs: {
                                              placeholder: "请输入微信模板ID",
                                              maxlength: "999",
                                            },
                                            model: {
                                              value:
                                                _vm.formChild.wechatTemplateId,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formChild,
                                                  "wechatTemplateId",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "formChild.wechatTemplateId",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "定价周期",
                                        prop: "salePeriod",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        [
                                          _c("el-input", {
                                            staticClass: "_width_214",
                                            attrs: {
                                              placeholder: "请输入数字",
                                              maxlength: "99",
                                              disabled: _vm.editType == "edit",
                                            },
                                            nativeOn: {
                                              keypress: function ($event) {
                                                return _vm.onKeyPress.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                            model: {
                                              value: _vm.formChild.salePeriod,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formChild,
                                                  "salePeriod",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formChild.salePeriod",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "_width_214",
                                          staticStyle: { "margin-top": "15px" },
                                          attrs: {
                                            placeholder: "请选择周期",
                                            disabled: _vm.editType == "edit",
                                          },
                                          model: {
                                            value: _vm.formChild.salePeriodUnit,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formChild,
                                                "salePeriodUnit",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formChild.salePeriodUnit",
                                          },
                                        },
                                        _vm._l(
                                          _vm.bizCode.sale_period_unit,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.dictKey,
                                              attrs: {
                                                label: item.dictValue,
                                                value: item.dictKey,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "首次续费",
                                        prop: "firstRenewPrice",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticStyle: { display: "flex" } },
                                        [
                                          _c("el-input", {
                                            staticClass: "_width_214",
                                            attrs: {
                                              maxlength: "99",
                                              placeholder: "请输入数字",
                                            },
                                            nativeOn: {
                                              keypress: function ($event) {
                                                return _vm.formatInput.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.formChild.firstRenewPrice,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formChild,
                                                  "firstRenewPrice",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "formChild.firstRenewPrice",
                                            },
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "padding-left": "5px",
                                              },
                                            },
                                            [_vm._v(" 元")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "后续续费",
                                        prop: "followRenewPrice",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticStyle: { display: "flex" } },
                                        [
                                          _c("el-input", {
                                            staticClass: "_width_214",
                                            attrs: {
                                              maxlength: "99",
                                              placeholder: "请输入数字",
                                            },
                                            nativeOn: {
                                              keypress: function ($event) {
                                                return _vm.formatInput.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.formChild.followRenewPrice,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formChild,
                                                  "followRenewPrice",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "formChild.followRenewPrice",
                                            },
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "padding-left": "5px",
                                              },
                                            },
                                            [_vm._v(" 元")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "el-collapse-item",
                    { attrs: { name: "4" } },
                    [
                      _c("template", { slot: "title" }, [
                        _c(
                          "div",
                          { staticClass: "_title" },
                          [
                            _vm._v(
                              "\n              商品折扣配置\n              "
                            ),
                            _c("el-tooltip", { attrs: { placement: "top" } }, [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _c("ul", [
                                    _c("li", [
                                      _vm._v(
                                        "标签折扣：通过选择不同类型的用户，设置不同的价格"
                                      ),
                                    ]),
                                  ]),
                                ]
                              ),
                              _c("i", {
                                staticClass: "header-icon el-icon-info",
                              }),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "_box" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "设置折扣" } },
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-value": "1",
                                  "inactive-value": "0",
                                  disabled: _vm.formChild.autoRenewFlag == "1",
                                },
                                model: {
                                  value: _vm.formChild.discountFlag,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formChild, "discountFlag", $$v)
                                  },
                                  expression: "formChild.discountFlag",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.formChild.discountFlag == "1"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "折扣类型",
                                    prop: "discountType",
                                  },
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.formChild.discountType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formChild,
                                            "discountType",
                                            $$v
                                          )
                                        },
                                        expression: "formChild.discountType",
                                      },
                                    },
                                    [
                                      _vm._l(
                                        _vm.bizCode.discount_type,
                                        function (item) {
                                          return [
                                            (
                                              _vm.formChild.memberTypeKey == 5
                                                ? item.dictKey == "4"
                                                : item.dictKey == "1"
                                            )
                                              ? _c(
                                                  "el-radio",
                                                  {
                                                    key: item.dictKey,
                                                    attrs: {
                                                      label: item.dictKey,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.dictValue)
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                  _vm.formChild.discountFlag == "1" &&
                                  _vm.formChild.discountType === "4"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "form_item_margin" },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "折扣价",
                                                  prop: "basicDiscountPrice",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                    },
                                                  },
                                                  [
                                                    _c("el-input", {
                                                      staticClass: "_width_214",
                                                      attrs: {
                                                        maxlength: "20",
                                                        placeholder:
                                                          "请输入折扣价",
                                                      },
                                                      on: {
                                                        input:
                                                          _vm.calculateDiscount,
                                                      },
                                                      nativeOn: {
                                                        keypress: function (
                                                          $event
                                                        ) {
                                                          return _vm.formatInput.apply(
                                                            null,
                                                            arguments
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.formChild
                                                            .basicDiscountPrice,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.formChild,
                                                            "basicDiscountPrice",
                                                            typeof $$v ===
                                                              "string"
                                                              ? $$v.trim()
                                                              : $$v
                                                          )
                                                        },
                                                        expression:
                                                          "formChild.basicDiscountPrice",
                                                      },
                                                    }),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          "padding-left": "5px",
                                                        },
                                                      },
                                                      [_vm._v(" 元/台")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm.formChild.memberTypeKey == 5
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "form_item_margin",
                                              },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    staticStyle: {
                                                      "margin-bottom": "15px",
                                                    },
                                                    attrs: {
                                                      label: "大屏数量折扣",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          type: "primary",
                                                          plain: "",
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.addScreenDiscount,
                                                        },
                                                      },
                                                      [_vm._v("新增档位")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._l(
                                                  _vm.formChild.pricingConfig,
                                                  function (item, index) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: index,
                                                        staticClass:
                                                          "add_screen_discount_box",
                                                      },
                                                      [
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            staticClass:
                                                              "add_screen_discount_item add_screen_discount_item_first",
                                                            attrs: {
                                                              prop: `pricingConfig.${index}.deviceQtyLimit`,
                                                              rules: [
                                                                {
                                                                  validator:
                                                                    _vm.validatePricingDeviceQtyLimit(
                                                                      item
                                                                    ),
                                                                  trigger:
                                                                    "blur",
                                                                },
                                                              ],
                                                            },
                                                          },
                                                          [
                                                            _c("div", [
                                                              _vm._v(
                                                                "购买数量>="
                                                              ),
                                                            ]),
                                                            _c("el-input", {
                                                              staticStyle: {
                                                                width: "130px",
                                                                margin:
                                                                  "0 10px",
                                                              },
                                                              attrs: {
                                                                maxlength: "99",
                                                                placeholder:
                                                                  "请输入购买数量",
                                                              },
                                                              nativeOn: {
                                                                keypress:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.onKeyPress.apply(
                                                                      null,
                                                                      arguments
                                                                    )
                                                                  },
                                                              },
                                                              model: {
                                                                value:
                                                                  item.deviceQtyLimit,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      item,
                                                                      "deviceQtyLimit",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "item.deviceQtyLimit",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "el-form-item",
                                                          {
                                                            staticClass:
                                                              "add_screen_discount_item add_screen_discount_item_second",
                                                            attrs: {
                                                              prop: `pricingConfig.${index}.unitPrice`,
                                                              rules: [
                                                                {
                                                                  validator:
                                                                    _vm.validatePricingUnitPrice(
                                                                      item
                                                                    ),
                                                                  trigger:
                                                                    "blur",
                                                                },
                                                              ],
                                                            },
                                                          },
                                                          [
                                                            _c("div", [
                                                              _vm._v(
                                                                "台, 享受"
                                                              ),
                                                            ]),
                                                            _c("el-input", {
                                                              staticStyle: {
                                                                width: "130px",
                                                                margin:
                                                                  "0 10px",
                                                              },
                                                              attrs: {
                                                                placeholder:
                                                                  "请输入折扣价格",
                                                              },
                                                              on: {
                                                                input:
                                                                  _vm.calculateDiscount,
                                                              },
                                                              nativeOn: {
                                                                keypress:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.formatInput.apply(
                                                                      null,
                                                                      arguments
                                                                    )
                                                                  },
                                                              },
                                                              model: {
                                                                value:
                                                                  item.unitPrice,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      item,
                                                                      "unitPrice",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "item.unitPrice",
                                                              },
                                                            }),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  margin:
                                                                    "0 10px 0 0",
                                                                },
                                                              },
                                                              [_vm._v("元/台")]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  color: "#999",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "折扣比例: " +
                                                                    _vm._s(
                                                                      item.discountRatio ||
                                                                        "-"
                                                                    )
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "el-button",
                                                              {
                                                                staticClass:
                                                                  "delete_button",
                                                                attrs: {
                                                                  type: "text",
                                                                  icon: "el-icon-delete",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.removeScreenDiscount(
                                                                        index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [_vm._v("删除")]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                              ],
                                              2
                                            )
                                          : _vm._e(),
                                        _vm.hasIOSChannel
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "form_item_margin",
                                              },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      label: "iOS内购商品",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "ios_purchase_box",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "ios_purchase_desc",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        iOS以可提审的价格倒推折扣价格，同时只支持上述档位的加购数量，且单次加购步长为上述档位\n                      "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "ios_purchase_example",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        举例：最终享受折扣价 138 元，10 台售价=1388，1388 可在苹果商店提审\n                      "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "ios_purchase_items",
                                                          },
                                                          _vm._l(
                                                            _vm.formChild
                                                              .pricingConfig,
                                                            function (
                                                              item,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key: index,
                                                                  staticClass:
                                                                    "ios_purchase_item",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                          档位 " +
                                                                      _vm._s(
                                                                        index +
                                                                          1
                                                                      ) +
                                                                      "：售价 " +
                                                                      _vm._s(
                                                                        _vm.calculateIOSPrice(
                                                                          item
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                  item.saleGoodsId !=
                                                                  "0"
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "（ID: " +
                                                                              _vm._s(
                                                                                item.saleGoodsId
                                                                              ) +
                                                                              "）"
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    : _vm._e(),
                                  _vm.formChild.discountFlag == "1" &&
                                  _vm.formChild.discountType === "1"
                                    ? [
                                        _c(
                                          "div",
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                staticStyle: {
                                                  "margin-top": "15px",
                                                },
                                                attrs: {
                                                  type: "primary",
                                                  plain: "",
                                                },
                                                on: {
                                                  click: _vm.addTerminalItem,
                                                },
                                              },
                                              [_vm._v("添加用户标签")]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._l(
                                          _vm.formChild.goodsDiscounts,
                                          function (item, index) {
                                            return _c(
                                              "div",
                                              {
                                                key: index,
                                                staticStyle: {
                                                  margin: "15px 0 15px -120px",
                                                  display: "flex",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "background-color":
                                                        "#EFF0F3",
                                                      width: "95%",
                                                      padding: "15px 15px 0 0",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "用户标签",
                                                          prop:
                                                            "goodsDiscounts." +
                                                            index +
                                                            ".labelUserTag",
                                                          rules:
                                                            _vm.getHobbyRules(
                                                              "请选择用户标签"
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            staticClass:
                                                              "_width_214",
                                                            attrs: {
                                                              placeholder:
                                                                "请选择用户标签",
                                                            },
                                                            model: {
                                                              value:
                                                                item.labelUserTag,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    item,
                                                                    "labelUserTag",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "item.labelUserTag",
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.bizCode
                                                              .label_user_tag,
                                                            function (item) {
                                                              return _c(
                                                                "el-option",
                                                                {
                                                                  key: item.dictKey,
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.cleanUpDuplicatesForUser(
                                                                        item.dictKey
                                                                      ),
                                                                    label:
                                                                      item.dictValue,
                                                                    value:
                                                                      item.dictKey,
                                                                  },
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "优惠价",
                                                          prop:
                                                            "goodsDiscounts." +
                                                            index +
                                                            ".labelDiscountPrice",
                                                          rules:
                                                            _vm.getHobbyRules(
                                                              "请输入优惠价"
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              display: "flex",
                                                            },
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              staticClass:
                                                                "_width_214",
                                                              attrs: {
                                                                placeholder:
                                                                  "请输入优惠价",
                                                              },
                                                              nativeOn: {
                                                                keypress:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.formatInput.apply(
                                                                      null,
                                                                      arguments
                                                                    )
                                                                  },
                                                              },
                                                              model: {
                                                                value:
                                                                  item.labelDiscountPrice,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      item,
                                                                      "labelDiscountPrice",
                                                                      typeof $$v ===
                                                                        "string"
                                                                        ? $$v.trim()
                                                                        : $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "item.labelDiscountPrice",
                                                              },
                                                            }),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  "padding-left":
                                                                    "5px",
                                                                },
                                                              },
                                                              [_vm._v(" 元")]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "优惠标签",
                                                        },
                                                      },
                                                      [
                                                        _c("el-input", {
                                                          staticClass:
                                                            "_width_214",
                                                          attrs: {
                                                            placeholder:
                                                              "请输入优惠标签",
                                                            maxlength: "20",
                                                          },
                                                          model: {
                                                            value:
                                                              item.discountTag,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "discountTag",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.discountTag",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "生效时间",
                                                        },
                                                      },
                                                      [
                                                        _c("el-date-picker", {
                                                          attrs: {
                                                            type: "datetimerange",
                                                            "range-separator":
                                                              "-",
                                                            "value-format":
                                                              "yyyy-MM-dd HH:mm:ss",
                                                            "start-placeholder":
                                                              "开始日期",
                                                            "end-placeholder":
                                                              "结束日期",
                                                          },
                                                          model: {
                                                            value: item.time,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "time",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.time",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c("div"),
                                                _c(
                                                  "el-button",
                                                  {
                                                    staticStyle: {
                                                      color: "#ff0000",
                                                      "margin-left": "10px",
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      icon: "el-icon-delete",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.formChild.goodsDiscounts =
                                                          _vm.formChild.goodsDiscounts.filter(
                                                            (i) => i !== item
                                                          )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("删除")]
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "el-collapse-item",
                    { attrs: { name: "5" } },
                    [
                      _c("template", { slot: "title" }, [
                        _c(
                          "div",
                          { staticClass: "_title" },
                          [
                            _vm._v(
                              "\n              商品描述配置\n              "
                            ),
                            _c("el-tooltip", { attrs: { placement: "top" } }, [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _c("ul", [
                                    _c("li", [
                                      _vm._v(
                                        "优惠标签：商品角标展示，参考图示"
                                      ),
                                    ]),
                                    _c("li", [
                                      _vm._v(
                                        "短、中、长描述：商品的不同文字描述，参考图示"
                                      ),
                                    ]),
                                  ]),
                                ]
                              ),
                              _c("i", {
                                staticClass: "header-icon el-icon-info",
                              }),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "_box" },
                        [
                          _c("div", { staticStyle: { display: "flex" } }, [
                            _c(
                              "div",
                              { staticStyle: { width: "70%" } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "goodsDisplayName",
                                      label: "商品展示名称",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "_width_214",
                                      attrs: {
                                        placeholder: "请输入商品展示名称",
                                        maxlength: "99",
                                      },
                                      model: {
                                        value: _vm.formChild.goodsDisplayName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formChild,
                                            "goodsDisplayName",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formChild.goodsDisplayName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "优惠标签" } },
                                  [
                                    _c("el-input", {
                                      staticClass: "_width_214",
                                      attrs: {
                                        placeholder: "请输入优惠标签",
                                        maxlength: "99",
                                      },
                                      model: {
                                        value: _vm.formChild.discountLabel,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formChild,
                                            "discountLabel",
                                            $$v
                                          )
                                        },
                                        expression: "formChild.discountLabel",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "短描述" } },
                                  [
                                    _c("el-input", {
                                      staticClass: "_width_214",
                                      attrs: {
                                        placeholder: "请输入短描述",
                                        maxlength: "99",
                                      },
                                      model: {
                                        value: _vm.formChild.shortDescription,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formChild,
                                            "shortDescription",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formChild.shortDescription",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "中描述" } },
                                  [
                                    _c("el-input", {
                                      staticClass: "_width_214",
                                      attrs: {
                                        placeholder: "请输入中描述",
                                        maxlength: "99",
                                      },
                                      model: {
                                        value: _vm.formChild.middleDescription,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formChild,
                                            "middleDescription",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formChild.middleDescription",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "长描述" } },
                                  [
                                    _c("el-input", {
                                      staticClass: "_width_300",
                                      attrs: {
                                        placeholder: "请输入长描述",
                                        maxlength: "9999",
                                      },
                                      model: {
                                        value: _vm.formChild.longDescription,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formChild,
                                            "longDescription",
                                            $$v
                                          )
                                        },
                                        expression: "formChild.longDescription",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "item_Example" }, [
                              _c("div", { staticClass: "example_box" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "memberBuy_buyList_item active",
                                  },
                                  [
                                    _c("div", { staticClass: "content" }, [
                                      _c("div", { staticClass: "day_length" }, [
                                        _c("div", { staticClass: "price" }, [
                                          _vm.formChild.presentPriceType != 3 &&
                                          _vm.formChild.presentPriceType != 4
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formChild
                                                      .promotePricePrefix
                                                  )
                                                ),
                                              ])
                                            : _vm._e(),
                                          _vm.formChild.presentPriceType != 3 &&
                                          _vm.formChild.presentPriceType != 4
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "font-size": "18px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(
                                                        _vm.formChild
                                                          .promotePrice
                                                          ? "￥" +
                                                              _vm.formChild
                                                                .promotePrice
                                                          : ""
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.formChild.presentPriceType != 3 &&
                                          _vm.formChild.presentPriceType != 4
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "font-size": "12px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formChild
                                                        .promotePriceSuffix
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.formChild.presentPriceType == 4
                                            ? _c(
                                                "span",
                                                { staticClass: "custom_text" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "custom_text_prefix",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getCustomText(
                                                            "prefix"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "custom_text_price",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getCustomText(
                                                            "price"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "custom_text_suffix",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getCustomText(
                                                            "suffix"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.formChild
                                                        .paidPricePrefix
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.formChild
                                                        .autoRenewFlag == 0
                                                        ? "￥" +
                                                            _vm.formChild
                                                              .salePrice
                                                        : "￥" +
                                                            _vm.formChild
                                                              .firstRenewPrice ||
                                                            "-"
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.formChild
                                                        .paidPriceSuffix
                                                    )
                                                ),
                                              ]),
                                        ]),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              color: "#FBDEBE",
                                              "font-weight": "normal",
                                              "font-size": "14px",
                                              display: "flex",
                                              "align-items": "center",
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    _vm.formChild
                                                      .goodsDisplayName ||
                                                      _vm.formChild.goodsName ||
                                                      "-"
                                                  ) +
                                                  "\n                          "
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]),
                                      _c("div", { staticClass: "desc" }, [
                                        _vm.formChild.presentPriceType != 3 &&
                                        _vm.formChild.presentPriceType != 4
                                          ? _c("div", [
                                              _vm._v(
                                                "\n                          " +
                                                  _vm._s(
                                                    _vm.formChild
                                                      .paidPricePrefix
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.formChild
                                                      .autoRenewFlag == 0
                                                      ? "￥" +
                                                          _vm.formChild
                                                            .salePrice
                                                      : "￥" +
                                                          _vm.formChild
                                                            .firstRenewPrice ||
                                                          "-"
                                                  ) +
                                                  _vm._s(
                                                    _vm.formChild
                                                      .paidPriceSuffix
                                                  ) +
                                                  "\n                        "
                                              ),
                                            ])
                                          : _vm._e(),
                                        _c("div", { staticClass: "desc_txt" }, [
                                          _c(
                                            "div",
                                            { staticClass: "long_desc" },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    _vm.formChild
                                                      .longDescription
                                                  ) +
                                                  "\n                          "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "short_desc" },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    _vm.formChild
                                                      .shortDescription
                                                  ) +
                                                  "\n                          "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                      _c(
                                        "span",
                                        { staticClass: "shortDescription" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.formChild.discountLabel)
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "firstQuarter_desc" },
                                        [
                                          _vm._v(
                                            "\n                        " +
                                              _vm._s(
                                                _vm.formChild.middleDescription
                                              ) +
                                              "\n                      "
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _c(
                            "el-form-item",
                            { attrs: { label: "备注" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  placeholder: "请输入备注",
                                  rows: "4",
                                  maxlength: "99999",
                                },
                                model: {
                                  value: _vm.formChild.remark,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formChild, "remark", $$v)
                                  },
                                  expression: "formChild.remark",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "el-collapse-item",
                    { attrs: { name: "6" } },
                    [
                      _c("template", { slot: "title" }, [
                        _c(
                          "div",
                          { staticClass: "_title" },
                          [
                            _vm._v(
                              "\n              商品价格呈现\n              "
                            ),
                            _c("el-tooltip", { attrs: { placement: "top" } }, [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [_c("ul", [_c("li", [_vm._v("暂无说明")])])]
                              ),
                              _c("i", {
                                staticClass: "header-icon el-icon-info",
                              }),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "_box" }, [
                        _c("div", { staticStyle: { display: "flex" } }, [
                          _c(
                            "div",
                            { staticStyle: { width: "80%" } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "商品呈现价格",
                                    prop: "presentPriceType",
                                  },
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      on: {
                                        change: _vm.presentPriceTypeChange,
                                      },
                                      model: {
                                        value: _vm.formChild.presentPriceType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formChild,
                                            "presentPriceType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formChild.presentPriceType",
                                      },
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 1 } }, [
                                        _vm._v("日均价格"),
                                      ]),
                                      _c("el-radio", { attrs: { label: 2 } }, [
                                        _vm._v("月均价格"),
                                      ]),
                                      _c("el-radio", { attrs: { label: 3 } }, [
                                        _vm._v("商品售价"),
                                      ]),
                                      _c("el-radio", { attrs: { label: 4 } }, [
                                        _vm._v("自定义文案"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.formChild.presentPriceType === 1
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "推广价格" } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" },
                                            },
                                            [
                                              _c("el-input", {
                                                staticClass: "_width_114",
                                                attrs: {
                                                  maxlength: "99",
                                                  placeholder: "请输入",
                                                },
                                                model: {
                                                  value:
                                                    _vm.formChild
                                                      .promotePricePrefix,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formChild,
                                                      "promotePricePrefix",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formChild.promotePricePrefix",
                                                },
                                              }),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "5px",
                                                    width: "80px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "￥" +
                                                      _vm._s(
                                                        _vm.formChild
                                                          .promotePrice
                                                          ? _vm.formChild
                                                              .promotePrice
                                                          : ""
                                                      ) +
                                                      "\n                      "
                                                  ),
                                                ]
                                              ),
                                              _c("el-input", {
                                                staticClass: "_width_114",
                                                attrs: {
                                                  maxlength: "99",
                                                  placeholder: "请输入",
                                                },
                                                model: {
                                                  value:
                                                    _vm.formChild
                                                      .promotePriceSuffix,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formChild,
                                                      "promotePriceSuffix",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formChild.promotePriceSuffix",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "实付价格" } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" },
                                            },
                                            [
                                              _c("el-input", {
                                                staticClass: "_width_114",
                                                attrs: {
                                                  maxlength: "99",
                                                  placeholder: "请输入",
                                                },
                                                model: {
                                                  value:
                                                    _vm.formChild
                                                      .paidPricePrefix,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formChild,
                                                      "paidPricePrefix",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formChild.paidPricePrefix",
                                                },
                                              }),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "5px",
                                                    width: "80px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "￥" +
                                                      _vm._s(
                                                        _vm.formChild
                                                          .autoRenewFlag == 0
                                                          ? _vm.formChild
                                                              .salePrice
                                                          : _vm.formChild
                                                              .firstRenewPrice ||
                                                              ""
                                                      )
                                                  ),
                                                ]
                                              ),
                                              _c("el-input", {
                                                staticClass: "_width_114",
                                                attrs: {
                                                  maxlength: "99",
                                                  placeholder: "请输入",
                                                },
                                                model: {
                                                  value:
                                                    _vm.formChild
                                                      .paidPriceSuffix,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formChild,
                                                      "paidPriceSuffix",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formChild.paidPriceSuffix",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.formChild.presentPriceType === 2
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "推广价格" } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" },
                                            },
                                            [
                                              _c("el-input", {
                                                staticClass: "_width_114",
                                                attrs: {
                                                  maxlength: "99",
                                                  placeholder: "请输入",
                                                },
                                                model: {
                                                  value:
                                                    _vm.formChild
                                                      .promotePricePrefix,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formChild,
                                                      "promotePricePrefix",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formChild.promotePricePrefix",
                                                },
                                              }),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "5px",
                                                    width: "80px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "￥" +
                                                      _vm._s(
                                                        _vm.formChild
                                                          .promotePrice
                                                          ? _vm.formChild
                                                              .promotePrice
                                                          : ""
                                                      )
                                                  ),
                                                ]
                                              ),
                                              _c("el-input", {
                                                staticClass: "_width_114",
                                                attrs: {
                                                  maxlength: "99",
                                                  placeholder: "请输入",
                                                },
                                                model: {
                                                  value:
                                                    _vm.formChild
                                                      .promotePriceSuffix,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formChild,
                                                      "promotePriceSuffix",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formChild.promotePriceSuffix",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "实付价格" } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" },
                                            },
                                            [
                                              _c("el-input", {
                                                staticClass: "_width_114",
                                                attrs: {
                                                  maxlength: "99",
                                                  placeholder: "请输入",
                                                },
                                                model: {
                                                  value:
                                                    _vm.formChild
                                                      .paidPricePrefix,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formChild,
                                                      "paidPricePrefix",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formChild.paidPricePrefix",
                                                },
                                              }),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "5px",
                                                    width: "80px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "￥" +
                                                      _vm._s(
                                                        _vm.formChild
                                                          .autoRenewFlag == 0
                                                          ? _vm.formChild
                                                              .salePrice
                                                          : _vm.formChild
                                                              .firstRenewPrice
                                                      )
                                                  ),
                                                ]
                                              ),
                                              _c("el-input", {
                                                staticClass: "_width_114",
                                                attrs: {
                                                  maxlength: "99",
                                                  placeholder: "请输入",
                                                },
                                                model: {
                                                  value:
                                                    _vm.formChild
                                                      .paidPriceSuffix,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formChild,
                                                      "paidPriceSuffix",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formChild.paidPriceSuffix",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.formChild.presentPriceType === 3
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "实付价格" } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" },
                                            },
                                            [
                                              _c("el-input", {
                                                staticClass: "_width_114",
                                                attrs: {
                                                  maxlength: "99",
                                                  placeholder: "请输入",
                                                },
                                                model: {
                                                  value:
                                                    _vm.formChild
                                                      .paidPricePrefix,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formChild,
                                                      "paidPricePrefix",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formChild.paidPricePrefix",
                                                },
                                              }),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "5px",
                                                    width: "80px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "￥" +
                                                      _vm._s(
                                                        _vm.formChild
                                                          .autoRenewFlag == 0
                                                          ? _vm.formChild
                                                              .salePrice
                                                          : _vm.formChild
                                                              .firstRenewPrice
                                                      )
                                                  ),
                                                ]
                                              ),
                                              _c("el-input", {
                                                staticClass: "_width_114",
                                                attrs: {
                                                  maxlength: "99",
                                                  placeholder: "请输入",
                                                },
                                                model: {
                                                  value:
                                                    _vm.formChild
                                                      .paidPriceSuffix,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formChild,
                                                      "paidPriceSuffix",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formChild.paidPriceSuffix",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.formChild.presentPriceType === 4
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "自定义文案",
                                            prop: "customText",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass: "_width_370",
                                            attrs: {
                                              placeholder: "请输入自定义文案",
                                              maxlength: "99",
                                            },
                                            model: {
                                              value: _vm.formChild.customText,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formChild,
                                                  "customText",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formChild.customText",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-top": "15px" },
                  attrs: { label: "商品状态", prop: "state" },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.formChild.state,
                        callback: function ($$v) {
                          _vm.$set(_vm.formChild, "state", $$v)
                        },
                        expression: "formChild.state",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("生效"),
                      ]),
                      _c("el-radio", { attrs: { label: "0" } }, [
                        _vm._v("失效"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "right" } },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("input", false)
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.goodsLocalSave },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.formChild.saleChannelList.length
        ? _c("channel-popups", {
            attrs: {
              "app-id":
                _vm.formChild.saleChannelList[_vm.channelIndex].channelIds,
              visible: _vm.showPopups,
            },
            on: {
              "update:visible": function ($event) {
                _vm.showPopups = $event
              },
              comfirm: _vm.handleConfirm,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }